<template>
  <v-snackbar
    :color="snackbar.color"
    right
    :multi-line="true"
    elevation="24"
    bottom
    v-model="snackbar.show"
    :timeout="3500"
  >
   <span v-html="snackbar.message"></span>
    <template v-slot:action="{ attrs }">
      <v-btn color="black" text v-bind="attrs" @click="snackbar.show = false">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
export default {
  name: "snack-bar",
  computed: {
    snackbar() {
      return this.$store.state.user.snackbar;
    },
  },
  mounted(){
       this.$store.dispatch("resetMessage");
  }
};
</script>